export default __webpack_public_path__ + "static/media/2020 Audited Financial Statement.c99e312a.pdf";